import {
  REQUEST_WEB_COUNTRIES, RECEIVE_WEB_COUNTRIES, RECEIVE_WEB_COUNTRY, COMPLETE_WEB_COUNTRIES,
} from '../actions/web-countries';

const reducer = (state = { items: [], loading: false, item: {} }, action) => {
  switch (action.type) {
    case REQUEST_WEB_COUNTRIES:
      return { ...state, loading: true };
    case RECEIVE_WEB_COUNTRIES:
      return { ...state, items: action.items, loading: false };
    case RECEIVE_WEB_COUNTRY:
      return { ...state, item: action.item, loading: false };
    case COMPLETE_WEB_COUNTRIES:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reducer;
